import script from "./popup-block.vue?vue&type=script&setup=true&lang=ts"
export * from "./popup-block.vue?vue&type=script&setup=true&lang=ts"

import "./popup-block.vue?vue&type=style&index=0&id=89f29352&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89f29352"]])

export default __exports__